export default "__VITE_ASSET__iXCSeG3U__"